<template>
    <div style="background: #FAFAFA;">
        <div class="container" style="padding-bottom: 40px; padding-top: 0.5rem; height: 100vh;">
            <div style="padding-bottom: 3rem;">
                <div class="top-spot mt-5">
                    <h5 @click="goBack()"><span><i class="fa fa-chevron-left"></i></span> Leaderboard</h5>
                    
                </div>

                <div class="challenge-leaderboard-holder">
                    <div class="challenge-leaderboard bg-c-leaderboard">
                        <h2 class="col-md-12">Challenge Leaderboard</h2>
                        <h6 class="col-md-6">Check out the leaderboard to see who is leading in each category, and strive to be the best.</h6>
                    </div>
                    <div class="view-navigator" @click="routeTo('/dashboard/challenge-leaderboard')">
                       <div>
                        <p>View Leaderboard</p>
                        <!-- <strong>Server upgrade is ongoing, check back later</strong> -->
                       </div>
                        <span><i class="fa fa-arrow-right"></i></span>
                    </div>
                </div>
                <!-- <div class="challenge-leaderboard-holder mt-5">
                    <div class="challenge-leaderboard bg-s-leaderboard">
                        <h2 class="col-md-12">Schools Leaderboard</h2>
                        <h6 class="col-md-6">Check out the leaderboard for the schools with superkids, make your school number ranking school.</h6>
                    </div>
                    <div class="view-navigator2" @click="routeTo('/dashboard/school-leaderboard')">
                        <div>
                            <p>View Leaderboard</p>
                           
                        </div>
                        <span><i class="fa fa-arrow-right"></i></span>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: "LeaderboardHome",
    components: {
    },

    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
                path: route
                })
                .catch(() => {
                // console.log("none")
            });
        },
        goBack() {
            this.$router.back();
        }, 
    }
};

</script>

<style scoped lang="scss">

.top-spot {
    margin-top: 30rem;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    h5 {
        cursor: pointer;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #4B4B4F;
        span {
            margin-right: 20px;
        }
    }
}

.bg-c-leaderboard {
    background-image: url('https://res.cloudinary.com/dr2wljdlc/image/upload/v1773049821/challenge-leaderboard_vxm0v7.svg');
}
.bg-s-leaderboard {
    background-image: url('https://res.cloudinary.com/dr2wljdlc/image/upload/v1773049820/school-leaderboard_jys5k3.svg');
}
.challenge-leaderboard {
    margin-top: 50px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 320px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    padding: 20px;
    padding-top: 80px;
    h2 {
        font-family: Nunito;
        font-weight: 800;
        font-size: 26px;
        line-height: 28px;
        color: #000000;
        text-align: left;
        margin-bottom: 40px;
    }
    h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        color: #1C2B3A;
        text-align: left;
    }
    
}

.view-navigator {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 20px;
    background: #DAF2FB;
    padding: 10px 15px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    margin-top: 16px;
    cursor: pointer;
    p {
        font-family: Lato;
        font-weight: 500;
        margin-bottom: 0;
        font-size: 16px;
        line-height: 27px;
        color: #1C2B3A;
        text-align: left;

    }
    strong {
        font-family: Lato;
        font-weight: 700;
        margin-bottom: 0;
        font-size: 18px;
        line-height: 27px;
        color: #1C2B3A;
        text-align: left;
        display: flex;
    }
}

.view-navigator2 {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 20px;
    background: #FBE26A;
    padding: 10px 15px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    margin-top: 16px;
    cursor: pointer;
    p {
        font-family: Lato;
        font-weight: 500;
        margin-bottom: 0;
        font-size: 16px;
        line-height: 27px;
        color: #1C2B3A;
        text-align: left;

    }
    strong {
        font-family: Lato;
        font-weight: 700;
        margin-bottom: 0;
        font-size: 18px;
        line-height: 27px;
        color: #1C2B3A;
        text-align: left;
        display: flex;
    }
}

@media (max-width: 768px) {
    .challenge-leaderboard {
        padding-top: 60px;
        h2 {
            font-size: 20px;
            margin-bottom: 13px;
        }
        h6 {
            line-height: 33px;
            font-size: 18px;
        }
    }
}

</style>